import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import ForgetPassword from './auth/forgetpwd/reducer';
import Profile from './auth/profile/reducer';
import Notifications from './notifications/reducer';
import Dashboard from './dashboard/reducer';
import Bookings from './bookings/reducer';
import BookingFilters from './bookingfilters/reducer';
const rootReducer = combineReducers({
	// public
	Layout,
	Login,
	Account,
	ForgetPassword,
	Profile,
	Notifications,
	Dashboard,
	Bookings,
	BookingFilters
});

export default rootReducer;
